import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter,Routes, Route } from 'react-router-dom';
import Visualizer from './components/Visualizer';
import Detector from "./components/Detector";
import MovenetLive from './components/MovenetLive';
import Home from './components/Home';
import DemoPage from './components/DemoPage';
import { base_url } from './util/GlobalConfigs';


/*
  Route
*/
// ********************************************************
let url_reg = /\/#\/([A-Za-z_-]+)/
let url = window.location.href
let new_url = window.location.href.replace(/\#\//,'')
window.history.pushState({},null,new_url)
let res=''
try{
  res = (url.match(url_reg)[1])
}
catch(e){
  res = 'home'
}
let compo = null
switch (res) {
  case 'home':
    compo = <Home />
    break;
  
  case 'detectors':
    compo = <Detector />
    break;

  case 'animator':
    compo = <Visualizer />
    break;
  
  case 'live_pose':
    compo = <MovenetLive />
    break;
  
  case 'demo':
    compo = <MovenetLive />
    break;
  
  default:
    compo = <Home />
    break;
}
// ********************************************************

ReactDOM.render(
    <BrowserRouter basename={base_url.slice(0,-1)}>
        <Routes>
            <Route path='/' element={<App/>}>
                <Route path='/' element={compo}></Route>
                <Route path='/animator' element={<Visualizer />}></Route>
                <Route path='/detectors' element={<Detector />}></Route>
                <Route path='/live_pose' element={<MovenetLive />}></Route>
                <Route path='/demo' element={<DemoPage />}></Route>
            </Route>
        </Routes>
    </BrowserRouter>,
    document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
